import React from 'react';
import { PageHeader } from '../../components/common/PageHeader';
import { ApiTab } from './ApiTab';

/**
 * API Configuration Page
 * Dedicated page for API keys and authentication settings
 */
export const ApiPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="API Configuration"
        description="Manage your API keys, authentication tokens, and integration settings"
      />
      <ApiTab />
    </div>
  );
};
